"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Fields;
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "Component", "FieldComponent", "fieldsState", "names", "originalRender", "subscription"];
function Fields(_ref) {
  var children = _ref.children,
    Component = _ref.Component,
    FieldComponent = _ref.FieldComponent,
    _ref$fieldsState = _ref.fieldsState,
    fieldsState = _ref$fieldsState === void 0 ? {} : _ref$fieldsState,
    names = _ref.names,
    originalRender = _ref.originalRender,
    subscription = _ref.subscription,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (!names.length) {
    if (!Component) {
      return (originalRender || children)((0, _extends2.default)({}, fieldsState, other));
    }
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, fieldsState, other));
  }
  var _names = (0, _toArray2.default)(names),
    name = _names[0],
    rest = _names.slice(1);
  return /*#__PURE__*/_react.default.createElement(FieldComponent, {
    name: name,
    subscription: subscription
  }, function (fieldState) {
    return /*#__PURE__*/_react.default.createElement(Fields, (0, _extends2.default)({
      Component: Component,
      FieldComponent: FieldComponent,
      fieldsState: (0, _extends2.default)({}, fieldsState, other, {
        [name]: fieldState
      }),
      names: rest,
      originalRender: originalRender || children,
      subscription: subscription
    }, other));
  });
}